/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState } from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import Avatar from "@material-ui/core/Avatar";
import { BrowserRouter as Router, Route, Link, Switch } from "react-router-dom";
import Base64Downloader, {
  triggerBase64Download,
} from "common-base64-downloader-react";
import { drawDOM, exportPDF } from "@progress/kendo-drawing";
import LoadingOverlay from "react-loading-overlay";

// TODO: Fix this, this is temporary fix
import NewTab from "./NewTab";

import { centerContent } from "../../Constants/styles";
import { getFullNameAbbreviation } from "../../utils/global";
import { X } from "../../Constants/assets";

// Stylings
const InnerContainer = styled.header`
  width: 650px;
  height: 370px;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  text-align: center;
  position: fixed;
  font-family: "Roboto", sans-serif;
  z-index: 101;
  animation: zoomIn 0.2s ease-in-out;
`;
const Header = styled.header`
  margin-bottom: 15px;
`;

// const Logo = styled(PMZoneLogo);
let flag = true;
function PrevReportPopUp({
  show,
  getUserPreviousGames,
  userId,
  gameId,
  endGameFunction,
  prevReports,
  toggleShow,
  getUserPreviousGameId,
  prevGameIds,
  openPrevReportForScreenShot,
  toggleDownloadReport,
  setGameUIdOfPrevGame,
  getReportTest,
}) {
  const getArrayOfReports = () => {
    if (flag) {
      flag = false;
      // getUserPreviousGames(userId);
      getUserPreviousGameId(userId);
    }
  };
  const getHour = (time) => {
    const d = Date.parse(time);
    const hour = new Date(d).toString().slice(15, 21);
    return hour;
  };
  const parseDate = (time) => {
    const originalDate = new Date(time);
    const dateFormatOptions = { year: 'numeric', month: '2-digit', day: '2-digit' , timeZoneName: 'short'};
    const timeFormatOptions = { hour: '2-digit', minute: '2-digit', second: '2-digit', timeZoneName: 'short', hour12:false};
    const formattedDateTemp = originalDate.toLocaleDateString("en-GB", dateFormatOptions).split(',')[0]
    const formattedDate = formattedDateTemp.split('/').reverse().join('-');
    const formattedTime = originalDate.toLocaleTimeString(undefined, timeFormatOptions).split(' ')[0];
    return `${formattedDate} ${formattedTime}`;
  };
  const getDate = (date) => {
    const d = Date.parse(date);
    const gameDate = new Date(d).toString().slice(0, 10);
    return gameDate;
  };
  const getYear = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    return year;
  };

  const [currentData, setCurrentData] = useState("dont read me yet");
  const [isActive, setIsActive] = useState(false);
  const { t } = useTranslation();

  if (show) {
    getArrayOfReports();
    return (
      <InnerContainer>
        <div style={{ padding: "3%", margin: "4px auto" }}>
          <Header>
            <div
              style={{
                width: "100%",
                display: "flex",
                textAlign: " left",
                fontWeight: "700",
                fontSize: "24px",
              }}
            >
              <div style={{ width: "90%" }}>{t('modals.previous_games.info_title')}</div>
              <X
                style={{ width: "10%", cursor: "pointer" }}
                onClick={() => toggleShow(false)}
              />
            </div>
            <div
              style={{
                width: "100%",
                fontWeight: "400",
                fontSize: "18px",
                textAlign: "left",
              }}
            >
            {t('modals.previous_games.info_text')}
            </div>
          </Header>
          <LoadingOverlay active={isActive} spinner>
            <div style={{ overflowY: "auto", maxHeight: "250px" }}>
              {prevGameIds.length != 0 &&
                prevGameIds.map((current, index) => {
                  if (current.gameUid != gameId) {
                    const isLast = index === prevGameIds.length - 1;
                    return (
                      <div key={index}>
                        <div style={{ width: "100%", display: "flex" }}>
                          <div style={{ width: "40%" }}>
                            {parseDate(current.creationDateTime)}
{/* 
                            {getDate(current.creationDateTime)},
                            {getHour(current.creationDateTime)},{" "}
                            {getYear(current.creationDateTime)} */}
                          </div>
                          {/* <div
                            style={{
                              width: "30%",
                              textAlign: "-webkit-center",
                            }}
                          >
                            <div
                              style={{
                                width: "50%",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={async () => {
                                // endGameFunction(
                                //     false,
                                //     userId,
                                //     current.gameUid,
                                //     'previous report',
                                // );
                                // setGameUIdOfPrevGame(current.gameUid);
                                // console.log('yoni tony', current);
                                setIsActive(true);
                                const obj = {
                                  prevGameId: current.gameUid,
                                  userId: current.userUid,
                                };
                                // console.log('isActive ', isActive);
                                setCurrentData(
                                  await getReportTest({
                                    gameAndUserIdObj: obj,
                                    needssummaryReport: true,
                                    sendByMail: true,
                                    previousReport: "view",
                                  })
                                );
                                setIsActive(false);
                              }}
                            >
                              Report
                            </div>
                          </div> */}
                          <div
                            style={{
                              width: "70%",
                              textAlign: "-webkit-center",
                            }}
                          >
                            <div
                              style={{
                                width: "50%",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                              onClick={async () => {
                                // toggleDownloadReport(true);
                                // endGameFunction(
                                //     false,
                                //     userId,
                                //     current.gameUid,
                                //     'previous report',
                                // );
                                // setGameUIdOfPrevGame(current.gameUid);
                                setIsActive(true);
                                const obj = {
                                  prevGameId: current.gameUid,
                                  userId: current.userUid,
                                };
                                setCurrentData(
                                  await getReportTest({
                                    gameAndUserIdObj: obj,
                                    needssummaryReport: true,
                                    sendByMail: true,
                                    previousReport: "download",
                                  })
                                );
                                setIsActive(false);
                              }}
                            >
                              {t('modals.previous_games.download_link')}
                            </div>
                          </div>
                        </div>
                        {!isLast && (
                          <hr
                            style={{
                              width: "100%",
                              border:
                                "1px solid {props => props.theme.colors.gray}",
                            }}
                          />
                        )}
                      </div>
                    );
                  }
                })}
              {prevGameIds.length == 0 && (
                <div>{t('modals.previous_games.no_previous_games')}</div>
              )}
            </div>
          </LoadingOverlay>
        </div>
        {/* <Router>
                    <Switch>
                        <Route exact path="/NewTab" component={NewTab} />
                        <ul>
                            <br />
                            <li>
                                <Link to="/NewTab" target="_blank">
                                    Open First Component
                                </Link>
                            </li>
                        </ul>
                    </Switch>
                </Router> */}
      </InnerContainer>
    );
  }
  return null;
}

export default PrevReportPopUp;
